export default "__VITE_ASSET__BuEgal8X__"